import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';
import useNavigation from '@Navigation/useNavigation';
import { useDeps } from '@Contexts/DI';

function useAIPageIndexControl() {
  const { aiPageControl } = useDeps();
  const { pathname, search } = useNavigation();
  const request = useRequest();
  const region = request.region || request.mainRegion;
  const keys = ['aiPageIndexControl', region, pathname, search];
  const defaultData = {
    view: 'default',
  };
  const { data } = useQuery({
    queryKey: keys,
    queryFn: async () => {
      if (!window.ninja || !aiPageControl) return defaultData;

      const mainPageView = await aiPageControl.getMainPageStructure();

      return {
        view: mainPageView || defaultData.view,
      };
    },
    placeholderData: (previousData) => previousData || defaultData,
  });

  return data;
}

export default useAIPageIndexControl;
